import {
  Match,
  getMatchDriverTimes,
  getMatchPickSequences,
} from "model/Match/Match";
import { getTrackThumbnailPath } from "model/Track/Track";
import {
  statTimesBestWithDriverIds,
  statTimesDnfRate,
  statTimesMedian,
} from "stats/TimeStats";
import {
  statTrackPicksPickRate,
  statTrackPicksBanRate,
  statTrackPicksAveragePickPosition,
  statTrackPicksPickedWhenAvailable,
} from "stats/TrackPickStats";

export type SharedTracksStats = {
  trackId: string;
  thumbnailPath: string;
  name: string;
  bestTime: { time: number | undefined; driverIds: string[] };
  medianTime: number | undefined;
  dnfRate: { rate: number | undefined; breakdown: string };
  pickRate: { rate: number | undefined; breakdown: string };
  banRate: { rate: number | undefined; breakdown: string };
  averagePickPosition: number | undefined;
  pickedWhenAvailable: { rate: number | undefined; breakdown: string };
};

export const getSharedTracksStats = (
  matches: Match[],
  trackId: string,
  trackName: string
): SharedTracksStats => {
  const pickSequences = matches.map(getMatchPickSequences);
  const times = matches.flatMap((m) => getMatchDriverTimes(m, false, trackId));

  return {
    trackId,
    thumbnailPath: getTrackThumbnailPath(trackId),
    name: trackName,
    bestTime: statTimesBestWithDriverIds(times),
    medianTime: statTimesMedian(times),
    dnfRate: statTimesDnfRate(times),
    pickRate: statTrackPicksPickRate(pickSequences, trackId),
    banRate: statTrackPicksBanRate(pickSequences, trackId),
    averagePickPosition: statTrackPicksAveragePickPosition(
      pickSequences,
      trackId
    ),
    pickedWhenAvailable: statTrackPicksPickedWhenAvailable(
      pickSequences,
      trackId
    ),
  };
};
